<template>
  <div class="payment-method-cards">
    <div class="row">
      <div class="col-sm-12 text-left">
        <div class="row">
          <div class="col-sm-12 m-b-16">
            <h4>{{ $t("paymentdetails.wechat.title") }}</h4>
          </div>
        </div>
        <div class="row qr-code">
          <div class="col-sm-12 text-center">
            <img :src="'data:image/jpeg;base64,' + pageDetails.qrCode" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../../router";
import { createNamespacedHelpers } from "vuex";

// set defaults
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.withCredentials = true;

const paymentNS = createNamespacedHelpers("payment");

export default {
  name: "paymentMethodWeChat",
  data() {
    return {
      form: {
        issuer: "",
      },
      time: 10, //in seconds
      countDownTimer: null,
      stateTimer: null,
    };
  },
  components: {},
  computed: {
    ...paymentNS.mapGetters(["pageDetails", "language", "hostedCheckoutId"]),
  },
  mounted() {
    this.stateTimer = setInterval(this.checkState, 2000);
  },
  methods: {
    ...paymentNS.mapActions(["updateState"]),
    ...paymentNS.mapActions(["getState"]),
    ...paymentNS.mapMutations(["resetState"]),
    ...paymentNS.mapActions(["setOverlayBox"]),

    checkState() {
      axios
        .get(`/get-state/` + this.hostedCheckoutId)
        .then((response) => {
          if (!response.data) {
            return;
          }

          if (response.data.page === "payment-method-details") {
            return;
          }

          clearInterval(this.stateTimer);
          if (response.data.page === "payment-success") {
            window.location.href = response.data.pageDetails.url;
          } else {
            document
              .getElementsByTagName("html")[0]
              .setAttribute("lang", this.language.toLowerCase());
            this.$router.push({ path: `/${response.data.page}` });
          }
        })
        .catch((error) => {
          clearInterval(this.stateTimer);
          if (error.response.status === 404) {
            router.push({ name: "payment-session-expired" });
          } else {
            router.push({ name: "payment-failure" });
          }
        });
    },
  },
};
</script>
